import { createApp } from 'vue';
import App from './app/App.vue';
import { eventSystem } from '@core/events/eventSystem';
import './app/ui/core/ripple';

import constants from '@core/utils/constants';
import.meta.glob('/src/app/features/**/controller.js', { eager: true });

import { setupStores } from '@core/store';
import { setupNetwork } from '/src/app/core/utils/network.js';
import { setupPolling } from '@core/utils/pollingEngine';
import { AppRouter, createAppRouter } from '@core/router';
import './assets/css/tailwind.conf.css';
import './assets/css/main.css';

const app = createApp(App);
eventSystem.install(app);
setupNetwork(window.$bus);
setupPolling(window.$bus);
setupStores(app);




const router = createAppRouter();
app.use(router);
AppRouter.makeInitialNaviation()
app.config.globalProperties.$constants = constants;
app.config.globalProperties.$router = router;

const autoMountList = [];
const globals = import.meta.glob('./**/*.global.vue', { eager: true });
const mounts  = import.meta.glob('./**/*.mount.vue',  { eager: true });
const all = { ...globals, ...mounts };
for (const path in all) {
  const component = all[path].default;
  const isMount = path.endsWith('.mount.vue');
  const suffix  = isMount ? '.mount.vue' : '.global.vue';
  const fileName = path.split('/').pop().replace(suffix, '');
  const name = fileName;
  app.component(name, component);
  if (isMount) autoMountList.push(name);
}
app.config.globalProperties.$autoMountComponents = autoMountList;

window.$router = router;
app.mount('#app');
window.$bus?.emit('app.ready');
